<template>
  <p class="psmall semibold tag" :class="tagClass">
    {{ label }}
  </p>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  label: {
    type: String,
    required: true,
  },
  type: {
    type: String,
    default: '',
    validator: (val) =>
      [
        'error',
        'success',
        'gradient',
        'warning',
        'gray',
        'error-light',
        'success-light',
        'info-light',
        'warning-light',
        'gray-light',
      ].includes(val),
  },
  icon: {
    type: [Object, Function],
    required: false,
  },
});

const tagClass = computed(() => props.type);
</script>

<style scoped lang="scss">
.tag {
  display: inline-flex;
  align-items: center;
  gap: 0.125rem;
  padding: 0.25rem 0.75rem;
  border-radius: 16px;
  width: fit-content;
  max-height: 1.75rem;
  flex-shrink: 0;
  color: var(--font-white);
  fill: var(--surface-default);
  white-space: nowrap;
}

/* Icon */
.tag-icon {
  fill: currentColor;
  flex-shrink: 0;
}

/* 유형 */
.default {
  background-color: var(--surface-gray);
  color: var(--font-dim);
  fill: var(--font-dim);
  outline: 1px solid var(--surface-gray);
}
/* 배경 dark */
.success {
  background-color: var(--success);
}
.error {
  background-color: var(--error);
}
.gradient {
  background: linear-gradient(90deg, rgba(144, 113, 216, 1) 0%, rgba(71, 95, 216, 1) 100%);
}
.warning {
  background-color: var(--warning);
}
.gray {
  background-color: var(--surface-gray-darker);
}
/* 배경 light */
.success-light {
  background-color: var(--success-dimmer);
  color: var(--success);
  fill: var(--success);
}
.error-light {
  background-color: var(--error-dimmer);
  color: var(--error);
  fill: var(--error);
}
.info-light {
  background-color: var(--surface-primary-dimmest);
  color: var(--info-dark);
  fill: var(--info-dark);
}
.warning-light {
  background-color: var(--warning-dimmer);
  color: var(--warning);
  fill: var(--warning);
}
.gray-light {
  background-color: var(--surface-gray);
  color: var(--font-dim);
  fill: var(--font-dim);
}
</style>
